/**
 * Monapix Keep Components
 * Register all components
 *
 * @package Monapix
 * @version 3.0.2
 * @author Binary Cats Inc.
 */

import Vue from 'vue'

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
Vue.component('invoices-form', require('~/components/invoice/Form.vue'));
Vue.component('invoices-details-item-edit', require('~/components/invoice/detail/Edit.vue'));

/**
 * Packaged components
 *
 */
require('~/components/laranote');



// WEBPACK FOOTER //
// ./resources/js/components/index.js